// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Instagram2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 18 18"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M5.85 1.5h6.3a4.35 4.35 0 014.35 4.35v6.3a4.35 4.35 0 01-4.35 4.35h-6.3a4.35 4.35 0 01-4.35-4.35v-6.3A4.35 4.35 0 015.85 1.5zM5.7 3A2.7 2.7 0 003 5.7v6.6A2.7 2.7 0 005.7 15h6.6a2.7 2.7 0 002.7-2.7V5.7A2.7 2.7 0 0012.3 3H5.7zm7.238 1.125a.937.937 0 110 1.875.937.937 0 010-1.875zM9 5.25a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Instagram2Icon
/* prettier-ignore-end */
